import TermsAndConditions from '@pages/TermsAndConditions.vue';
import PrivacyPolicy from '@pages/PrivacyPolicy.vue';
import NotFound from '@pages/404.vue';
import CashCallDetails from '../pages/CashCallDetails.vue';
import CashCallRedirect from '../pages/CashCallRedirect.vue';

export default [
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
    meta: {
      noBodyBackground: true,
    },
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      noBodyBackground: true,
    },
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      flexContainer: true,
      noBodyBackground: true,
    },
  },
  {
    path:'/cash-call',
    name: 'CashCallDetails',
    component: CashCallDetails,
    meta: {
      permissions: [
        {
          role: 'Guest',
          access: false,
          redirect: 'Home'
        }
      ],
      requiresCashCallAccess: true
    }
  },
  {
      path: '/cash-call/email/action',
      name: 'CashCallRedirect',
      component: CashCallRedirect,
      meta: {
        requiresCashCallAccess: true
      }
  }
];
